<div class="bottom-sheet">
    <div> {{name}} </div>
    <button mat-button type="button" color="primary" (click)="clearBar($event)">Abbrechen</button>
    <button mat-button class="change" type="submit" (click)="changeStatus()">Aktualisieren</button>
</div>